module.exports = __webpack_public_path__ + "img/luach_no.b030c988.png";